export function EFAddIcon() {
  return (
    <svg
      width='30'
      height='29'
      viewBox='0 0 25 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.1846 7C13.1846 6.80109 13.1056 6.61032 12.9649 6.46967C12.8242 6.32902 12.6335 6.25 12.4346 6.25C12.2357 6.25 12.0449 6.32902 11.9042 6.46967C11.7636 6.61032 11.6846 6.80109 11.6846 7V11.25H7.43457C7.23566 11.25 7.04489 11.329 6.90424 11.4697C6.76359 11.6103 6.68457 11.8011 6.68457 12C6.68457 12.1989 6.76359 12.3897 6.90424 12.5303C7.04489 12.671 7.23566 12.75 7.43457 12.75H11.6846V17C11.6846 17.1989 11.7636 17.3897 11.9042 17.5303C12.0449 17.671 12.2357 17.75 12.4346 17.75C12.6335 17.75 12.8242 17.671 12.9649 17.5303C13.1056 17.3897 13.1846 17.1989 13.1846 17V12.75H17.4346C17.6335 12.75 17.8242 12.671 17.9649 12.5303C18.1056 12.3897 18.1846 12.1989 18.1846 12C18.1846 11.8011 18.1056 11.6103 17.9649 11.4697C17.8242 11.329 17.6335 11.25 17.4346 11.25H13.1846V7Z'
        fill='var(--icon-color-light-theme)'
      />
    </svg>
  )
}
